import { render, staticRenderFns } from "./AwardWriteDefaultLayout.vue?vue&type=template&id=edac6252&scoped=true"
import script from "./AwardWriteDefaultLayout.vue?vue&type=script&lang=js"
export * from "./AwardWriteDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edac6252",
  null
  
)

export default component.exports